import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

interface UpdateTemplatePayload {
  id: number;
  query?: string;
  extra_instructions?: string;
  deep_mode?: boolean;
  visibility?: string;
  tags?: string[];
}

const updateAnalysisTemplate = async (payload: UpdateTemplatePayload): Promise<any> => {
  const { id, ...data } = payload;
  const response = await instance.put(`/nexa/analysis-templates/${id}`, data);
  return response.data;
};

export const useUpdateAnalysisTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAnalysisTemplate,
    onSuccess: () => {
      message.success('Analysis template updated successfully');
      queryClient.invalidateQueries({ queryKey: ['analysis-templates'] });
      queryClient.invalidateQueries({ queryKey: ['analysis-tags'] });
      queryClient.invalidateQueries({ queryKey: ['my-analyses'] });
      queryClient.invalidateQueries({ queryKey: ['team-analyses'] });
      queryClient.invalidateQueries({ queryKey: ['recommended-analyses'] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.error?.message || 'Failed to update analysis template');
    },
  });
};
